import React, { useEffect, useState } from "react";
import { getDriver } from "api/users";
import { Driver } from "typings/models";
import { Card, CardContent, Typography, CircularProgress, Box, Divider } from "@mui/material";

const DriverDetailsPage: React.FC = () => {
    const [driver, setDriver] = useState<Driver | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchDriver = async () => {
            const driverData = await getDriver();
            setDriver(driverData);
            setLoading(false);
        };
        fetchDriver();
    }, []);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3 }}>
            <Card>
                <CardContent>
                    <Typography variant="h6" textAlign="center"><strong> {driver?.name} </strong></Typography>
                    <Divider />
                    <br />
                    <Typography><strong>Email:</strong> {driver?.email}</Typography>
                    <Typography><strong>Teléfono:</strong> {driver?.phone}</Typography>
                </CardContent>
            </Card>
        </Box>
    );
};

export default DriverDetailsPage;
